// src/pages/AuthCallback.tsx
import React, { useEffect, useRef, useState } from "react";
import { handleAuthCallback } from "../auth/client";

const AuthCallback: React.FC = () => {
  const [err, setErr] = useState<string | null>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return; // ignore StrictMode double-invoke
    ranRef.current = true;
    (async () => {
      try {
        await handleAuthCallback();
        window.history.replaceState({}, "", "/");
        window.location.assign("/");
      } catch (e: any) {
        setErr(e?.message || String(e));
      }
    })();
  }, []);

  return (
    <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
      {err ? (<><h3>Sign-in failed</h3><pre>{err}</pre></>) : <p>Signing you in…</p>}
    </div>
  );
};

export default AuthCallback;
